import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=6014a006&scoped=true&"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=6014a006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014a006",
  null
  
)

export default component.exports